export default "__VITE_ASSET__BEVh9koa__"